import { ReactElement } from 'react';

import { Stack } from '@mui/material';
import Modal from '~/ui/components/common/Modal';
import NoteHeader from '~/ui/components/reusable/Notes/Header';
import NoteForm from '~/ui/components/reusable/Notes/NoteForm';

import { IPatientInfo, IPatientLatestReadings } from '~/services/api/patients/types';
import { IFormValues } from '~/ui/components/reusable/Notes/NoteForm/types';
import styles from './NoteModal.module.scss';
import LatestReadings from '~/ui/components/reusable/LatestReadings';
import { IBloodPressureReading } from '~/services/api/readings/types';

interface IProps {
  mode?: 'create' | 'edit';
  patient: IPatientInfo;
  latestReadings: IPatientLatestReadings;
  initialValues: IFormValues;
  isProcessing: boolean;
  onClose: () => void;
  onSubmit: (values: IFormValues) => void;
  onBloodPressureUpdated: (data: IBloodPressureReading) => void;
}

const NoteModal = ({
  mode = 'create',
  patient,
  latestReadings,
  initialValues,
  isProcessing,
  onClose,
  onSubmit,
  onBloodPressureUpdated,
}: IProps): ReactElement => {
  const title = mode === 'create' ? 'Add Note' : 'Update Note';

  return (
    <Modal open isDraggable title={title} className={styles.modal} onClose={onClose}>
      <div className={styles.inner}>
        <Stack spacing={1}>
          {patient && (
            <NoteHeader
              fullName={patient.fullName}
              subjectId={patient.subjectId}
              dateOfBirth={patient.dateOfBirth}
            />
          )}
          {latestReadings && (
            <LatestReadings
              latestReadings={latestReadings.latestReadings}
              notificationRules={latestReadings.notificationRules}
              timezone={patient.timezone}
              onBloodPressureUpdated={onBloodPressureUpdated}
            />
          )}
        </Stack>

        <NoteForm
          mode={mode}
          initialValues={initialValues}
          isProcessing={isProcessing}
          onSubmit={onSubmit}
          onClose={onClose}
        />
      </div>
    </Modal>
  );
};

export default NoteModal;
